<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge() && !modeAjout()" class="grid">
	<div class="col-12">
		<p-card>
			<h5>Location - {{location.description}}
				<span [class]="'statut ' + location.statut.nom.replace(' ','').toLowerCase()">
					{{location.statut.nom}}
				</span>
			</h5>
			@if (afficherMessageEnAttente()) {
				<p-message severity="info" styleClass="w-full mt-3"
					text="Le statut est « En attente » car la date de début n'est pas renseignée.">
				</p-message>
			}
			<p-menubar autoDisplay="false" [model]="menu">
				<p-button *ngIf="estAutorise('location_modifier') && modeConsultation() && estModifiable"
					(click)="surBoutonModifier()" icon="pi pi-pencil" styleClass="p-button-primary"></p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="enregistrerModifications()" label
					icon="pi pi-check" styleClass="p-button-success mr-2">
				</p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="surBoutonAnnulerModification($event)"
					icon="pi pi-times" styleClass="p-button-secondary"></p-button>
			</p-menubar>
		</p-card>

	</div>
</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" orientation="left" (onChange)="surChangementOnglet($event)">
				<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
					<!-- <p-divider align="left">
				<div class="inline-flex align-items-center">
					<b>Informations générales</b>
				</div>
				</p-divider> -->
					<div class="fluid formgrid grid">

						<!-- Rental Type Section -->
						<div class="flex flex-column gap-3 my-2 col-12 lg:col-3">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-tag text-primary"></i>
								<label class="font-medium">Type de location<span class="text-red-500">*</span></label>
							</div>
							<div class="p-input-filled">
								<input *ngIf="modeConsultation()" 
									   type="text" 
									   pInputText 
									   readonly
									   class="w-full"
									   [value]="location.typeLocation.nom">
								<p-dropdown *ngIf="!modeConsultation()" 
									 [options]="typesLocation"
									 [(ngModel)]="location.typeLocation" 
									 optionLabel="nom" 
									 [showClear]="true" 
									 filter="true"
									 filterBy="numero,nom" 
									 (onHide)="surFermetureTypeLocation()"
									 placeholder="Sélectionner un type de location..."
									 styleClass="w-full">
									<ng-template pTemplate="selectedItem">
										<div *ngIf="location.typeLocation" class="flex align-items-center gap-2">
											<i class="pi pi-check-circle text-primary"></i>
											<span>{{location.typeLocation.nom}}</span>
										</div>
									</ng-template>
									<ng-template let-type pTemplate="item">
										<div class="flex align-items-center gap-2">
											<span>{{type.nom}}</span>
										</div>
									</ng-template>
								</p-dropdown>
								<small class="p-error" *ngIf="submitted && !location.typeLocation">
									<i class="pi pi-exclamation-circle"></i> Le type de location est obligatoire
								</small>
							</div>
						</div>

						<!-- Supplier Section -->
						<div class="flex flex-column gap-3 my-2 col-12 lg:col-9">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-building text-primary"></i>
								<label class="font-medium">Fournisseur<span class="text-red-500">*</span></label>
							</div>
							<div class="p-input-filled">
								<input *ngIf="modeConsultation()" 
									   type="text" 
									   pInputText 
									   readonly
									   class="w-full"
									   [value]="location.fournisseur.nom + ' (' + location.fournisseur.numero + ')'">
								<p-dropdown *ngIf="!modeConsultation()" 
									 [options]="fournisseurs" 
									 [virtualScroll]="true"
									 [virtualScrollItemSize]="38"
									 [(ngModel)]="location.fournisseur" 
									 optionLabel="nom" 
									 [showClear]="true" 
									 filter="true"
									 filterBy="numero,nom" 
									 placeholder="Sélectionner un fournisseur..."
									 styleClass="w-full">
									<ng-template pTemplate="selectedItem">
										<div *ngIf="location.fournisseur" class="flex align-items-center gap-2">
											<i class="pi pi-check-circle text-primary"></i>
											<span>{{location.fournisseur.nom}}</span>
											<span class="text-500">({{location.fournisseur.numero}})</span>
										</div>
									</ng-template>
									<ng-template let-fournisseur pTemplate="item">
										<div class="flex align-items-center gap-2">
											<span>{{fournisseur.nom}}</span>
											<span class="text-500">({{fournisseur.numero}})</span>
										</div>
									</ng-template>
								</p-dropdown>
								<small class="p-error" *ngIf="submitted && !location.fournisseur">
									<i class="pi pi-exclamation-circle"></i> Le fournisseur est obligatoire
								</small>
							</div>
						</div>

					</div>

					<!-- Description Section -->
					<div class="fluid formgrid grid mt-3">
						<div class="flex flex-column gap-3 my-2 col-12">
							<div class="flex align-items-center justify-content-between">
								<div class="flex align-items-center gap-2">
									<i class="pi pi-info-circle text-primary"></i>
									<label class="font-medium">Description<span class="text-red-500">*</span></label>
								</div>
								<button *ngIf="!modeConsultation()"
										pButton 
										pRipple 
										icon="pi pi-copy" 
										[disabled]="!location.item?.description"
										class="p-button-text p-button-rounded"
										pTooltip="Copier la description de l'équipement"
										tooltipPosition="left"
										(click)="location.description = location.item.description">
								</button>
							</div>
							<div class="p-input-filled">
								<input [readonly]="modeConsultation()" 
									   type="text" 
									   pInputText 
									   class="w-full"
									   [(ngModel)]="location.description" 
									   placeholder="Entrez une description détaillée..."
									   autocomplete="off" />
								<small class="p-error" *ngIf="submitted && !location.description">
									<i class="pi pi-exclamation-circle"></i> La description est obligatoire
								</small>
							</div>
						</div>
					</div>

					<!-- Dates Section -->
					<div class="fluid formgrid grid mt-3">
						<div class="flex flex-column gap-3 my-2 col-12 md:col-6 lg:col-3">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-calendar text-primary"></i>
								<label class="font-medium">Date de début</label>
							</div>
							<div class="p-input-filled">
								<input *ngIf="modeConsultation()" 
									   type="text" 
									   pInputText 
									   readonly
									   class="w-full"
									   [value]="location.dateDebut ? (location.dateDebut | date:'yyyy-MM-dd') : '—'">
								<p-calendar *ngIf="!modeConsultation()" 
									 appendTo="body" 
									 [showIcon]="true"
									 [(ngModel)]="location.dateDebut" 
									 dateFormat="yy-mm-dd" 
									 [yearNavigator]="true"
									 [monthNavigator]="true" 
									 yearRange="2000:2040"
									 styleClass="w-full"
									 placeholder="Sélectionner une date...">
								</p-calendar>
							</div>
						</div>

						<div class="flex flex-column gap-3 my-2 col-12 md:col-6 lg:col-3">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-calendar-times text-primary"></i>
								<label class="font-medium">Date de fin prévue@if (dateFinObligatoire()) {<span class="text-red-500">*</span>}</label>
							</div>
							<div class="p-input-filled">
								<input *ngIf="modeConsultation()" 
									   type="text" 
									   pInputText 
									   readonly
									   class="w-full"
									   [value]="location.dateFin ? (location.dateFin | date:'yyyy-MM-dd') : '—'">
								<p-calendar *ngIf="!modeConsultation()" 
									 appendTo="body" 
									 [showIcon]="true"
									 [(ngModel)]="location.dateFin" 
									 dateFormat="yy-mm-dd" 
									 [yearNavigator]="true"
									 [monthNavigator]="true" 
									 yearRange="2000:2040"
									 styleClass="w-full"
									 placeholder="Sélectionner une date...">
								</p-calendar>
								<small class="p-error" *ngIf="submitted && dateFinObligatoire() && !location.dateFin">
									<i class="pi pi-exclamation-circle"></i> La date de fin est obligatoire lorsque la date de début est renseignée
								</small>
							</div>
						</div>
					</div>

					<!-- Equipment Details Section -->
					<div class="fluid formgrid grid mt-3">
						<div class="flex flex-column gap-3 my-2 col-12 md:col-6 lg:col-3">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-dollar text-primary"></i>
								<label class="font-medium">Valeur de l'équipement</label>
								<i class="pi pi-info-circle text-500 cursor-pointer" 
								   pTooltip="Valeur marchande actuelle de l'équipement"></i>
							</div>
							<div class="p-input-filled">
								<p-inputNumber [readonly]="modeConsultation()" 
										 #champPrix
										 [(ngModel)]="location.valeurEquipement" 
										 mode="currency" 
										 currency="USD" 
										 locale="en-US"
										 [inputStyleClass]="'w-full'"
										 placeholder="0.00">
								</p-inputNumber>
							</div>
						</div>

						<div class="flex flex-column gap-3 my-2 col-12 md:col-6 lg:col-3">
							<div class="flex align-items-center gap-2">
								<i class="pi pi-clock text-primary"></i>
								<label class="font-medium">Heures initiales</label>
								<i class="pi pi-info-circle text-500 cursor-pointer" 
								   pTooltip="Nombre d'heures au compteur au début de la location"></i>
							</div>
							<div class="p-input-filled">
								<input *ngIf="modeConsultation()" 
									   type="text" 
									   pInputText 
									   readonly
									   class="w-full"
									   [value]="location.heuresDebut">
								<p-inputNumber *ngIf="!modeConsultation()" 
										 [min]="0" 
										 [(ngModel)]="location.heuresDebut"
										 placeholder="0"
										 [showButtons]="true"
										 buttonLayout="horizontal"
										 spinnerMode="horizontal"
										 [inputStyleClass]="'w-full'"
										 decrementButtonClass="p-button-secondary" 
										 incrementButtonClass="p-button-secondary">
								</p-inputNumber>
							</div>
						</div>
					</div>

					<p-divider align="left">
						<b>Suivi des heures de l'équipement</b>
					</p-divider>

					<div class="fluid formgrid grid">
						<div class="flex flex-column gap-2 my-2 col-3">
							<label for="description">Équipement</label>
							<div class="flex align-items-center gap-2">
								<div *ngIf="!modeConsultation()" class="text-900 p-2 surface-100 border-round flex-grow-1">{{location.nouvelItem ? 'Nouvel équipement - ' + (location.nouvelItem.numero) : ((location.item?.numero | valeurVide) + ' - ' + (location.item?.description | valeurVide))}}</div>
								<button *ngIf="modeConsultation() && location.item" pButton pRipple class="p-button-text flex-grow-1" 
									routerLink="/item/{{location.item?.itemId}}">{{location.item?.numero + ' - ' + location.item?.description}}</button>
								<button *ngIf="!modeConsultation()" pButton pRipple icon="pi pi-plus" class="p-button-rounded p-button-primary"
									(click)="ajouterItem()" pTooltip="Créer un nouvel équipement"></button>
								<button *ngIf="!modeConsultation() && !location.nouvelItem" pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-primary"
									(click)="selectionnerItem()" pTooltip="Sélectionner un équipement"></button>
								<button *ngIf="!modeConsultation()" pButton pRipple icon="pi pi-times" class="p-button-rounded p-button-secondary"
									(click)="retirerItem()" pTooltip="Retirer l'équipement"></button>
							</div>
						</div>
						<div class="flex flex-column gap-2 my-2 col-3">
							<label for="description">Nb heures prévues par mois</label>
							<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly
								value="{{location.nbHeuresParMois}}">
								<p-inputNumber *ngIf="!modeConsultation()" [min]="0" [(ngModel)]="location.nbHeuresParMois">
								</p-inputNumber>
						</div>
					</div>
					<p-divider align="left">
						<b>Coûts</b>
					</p-divider>

					<div class="fluid formgrid grid" *ngIf="modeConsultation() && location.statut.statutId == 13">
						<div class="flex flex-column gap-2 my-2 col-3">
							<label for="coutTotal" style="font-weight: 800;">Coût total calculé : </label>
							{{location.coutLocation | currency}}

						</div>
					</div>

					<p-panel *ngFor="let cout of location.couts; let i = index" styleClass="my-2" [toggleable]="true">
						<ng-template pTemplate="header">
							<div class="flex align-items-center gap-3 pl-3">
								<span class="font-bold">Coût #{{i + 1}}</span>
								<span class="text-sm text-500">{{cout.description}}</span>
								<span class="ml-auto font-bold text-primary">{{cout.prix * cout.quantite | currency}}</span>
							</div>
						</ng-template>
						
						<div class="grid p-3">
							<div class="col-12 md:col-6 lg:col-3">
								<div class="flex flex-column gap-2">
									<div class="flex align-items-center gap-2">
										<i class="pi pi-info-circle text-primary"></i>
										<label for="descriptionCout" class="font-medium">Description<span class="text-red-500">*</span></label>
										<i *ngIf="!modeConsultation()" 
										   class="pi pi-copy cursor-pointer hover:text-primary transition-colors transition-duration-150"
										   pTooltip="Copier la description"
										   (click)="copierDescription(cout)">
										</i>
									</div>
									<div class="p-input-filled">
										<input [readonly]="modeConsultation()" 
											   type="text" 
											   pInputText 
											   id="descriptionCout"
											   [(ngModel)]="cout.description" 
											   class="w-full"
											   placeholder="Entrez une description..."
											   autocomplete="off" />
									</div>
								</div>
							</div>

							<div class="col-12 md:col-6 lg:col-3">
								<div class="flex flex-column gap-2">
									<div class="flex align-items-center gap-2">
										<i class="pi pi-hashtag text-primary"></i>
										<label for="quantiteCout" class="font-medium">Quantité</label>
									</div>
									<div class="p-input-filled">
										<input *ngIf="modeConsultation()" 
											   type="text" 
											   pInputText 
											   readonly
											   class="w-full"
											   [value]="cout.quantite">
										<p-inputNumber *ngIf="!modeConsultation()" 
												 [min]="0" 
												 [(ngModel)]="cout.quantite"
												 placeholder="0"
												 [showButtons]="true"
												 buttonLayout="horizontal"
												 spinnerMode="horizontal"
												 [inputStyleClass]="'w-full'"
												 decrementButtonClass="p-button-secondary" 
												 incrementButtonClass="p-button-secondary">
										</p-inputNumber>
									</div>
								</div>
							</div>

							<div class="col-12 md:col-6 lg:col-3">
								<div class="flex flex-column gap-2">
									<div class="flex align-items-center gap-2">
										<i class="pi pi-box text-primary"></i>
										<label class="font-medium">Unité</label>
									</div>
									<input *ngIf="modeConsultation()" 
										   type="text" 
										   pInputText 
										   readonly
										   class="w-full"
										   [value]="cout.unite?.nom">
									<p-dropdown *ngIf="!modeConsultation()" 
											 [options]="unites" 
											 [(ngModel)]="cout.unite"
											 optionLabel="nom" 
											 appendTo="body" 
											 [showClear]="true" 
											 filter="true" 
											 filterBy="code,nom"
											 placeholder="Sélectionner une unité..."
											 styleClass="w-full">
										<ng-template pTemplate="selectedItem">
											<div *ngIf="cout.unite" class="flex align-items-center gap-2">
												<i class="pi pi-check-circle text-primary"></i>
												<span>{{cout.unite?.nom}}</span>
											</div>
										</ng-template>
										<ng-template let-unite pTemplate="item">
											<div class="flex align-items-center gap-2">
												<span>{{unite.nom}}</span>
												<span class="text-500">({{unite.code}})</span>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>

							<div class="col-12 md:col-6 lg:col-3">
								<div class="flex flex-column gap-2">
									<div class="flex align-items-center gap-2">
										<i class="pi pi-dollar text-primary"></i>
										<label class="font-medium">Prix unitaire</label>
									</div>
									<input *ngIf="modeConsultation()" 
										   type="text" 
										   pInputText 
										   readonly
										   class="w-full"
										   [value]="cout.prix | currency">
									<p-inputNumber *ngIf="!modeConsultation()" 
											 [(ngModel)]="cout.prix" 
											 mode="currency"
											 currency="USD" 
											 locale="en-US"
											 [inputStyleClass]="'w-full'"
											 placeholder="0.00">
									</p-inputNumber>
								</div>
							</div>

							<div class="col-12 flex justify-content-end" *ngIf="!modeConsultation()">
								<button pButton 
										pRipple 
										icon="pi pi-trash" 
										class="p-button-danger p-button-rounded" 
										pTooltip="Supprimer ce coût"
										(click)="supprimerCout(cout)">
								</button>
							</div>
						</div>
					</p-panel>
					<div class="flex justify-content-between align-items-center gap-2 my-4 px-2">
						<div class="flex align-items-center gap-2" *ngIf="location.couts?.length > 0">
							<i class="pi pi-calculator text-primary text-xl"></i>
							<span class="font-medium">Total: </span>
							<span class="font-bold text-primary text-xl">
								{{location.couts | totalCosts | currency}}
							</span>
						</div>
						
						<button *ngIf="!modeConsultation()" 
								pButton 
								pRipple 
								icon="pi pi-plus" 
								label="Ajouter un coût"
								class="p-button-primary" 
								(click)="ajouterCout()">
						</button>
					</div>



					<p-divider align="left" *ngIf="!modeAjout()">
						<div class="inline-flex align-items-center">
							<b class="mr-3">Bon de commande</b>
							<span *ngIf="location.bonCommande"
								[class]="'statut ' + location.bonCommande.statut.nom.replace(' ','').toLowerCase()">
								{{location.bonCommande.statut.nom}}
							</span>
						</div>
					</p-divider>

					<div class="grid" *ngIf="estAutorise('bdc_creer') && !location.bonCommande && modeConsultation()">
						<div class="flex flex-column gap-2 my-2 col-12" *ngIf="estModifiable">
							<p-button label="Créer le bon de commande" (click)="creerBdc()" icon="pi pi-plus"
								iconPos="left">
							</p-button>
						</div>
					</div>
					<div class="fluid formgrid grid" *ngIf="location.bonCommande">
						<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
							<label for="firstname">Numéro</label>
							<input id="firstname" type="text" pInputText readonly
								value="{{location.bonCommande.numero}}">
						</div>
						<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
							<label for="dateBdc">Date</label>
							<input id="dateBdc" type="date" pInputText readonly
								value="{{location.bonCommande.dateAchat | date:'yyyy-MM-dd'}}">
						</div>
						<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3"
							*ngIf="estAutorise('bdc_detail') && modeConsultation()">
							<label for="voirBdc">&nbsp;</label>
							<button pButton pRipple icon="pi pi-eye" class="p-button-success mr-2"
								(click)="voirBdc()"></button>
						</div>
					</div>

					<p-divider align="left">
						<div class="inline-flex align-items-center">
							<b>Information supplémentaire</b>
						</div>
					</p-divider>

					<div class="fluid formgrid grid">
						<div class="flex flex-column gap-2 my-2 col-12">
							<label for="lastname">Emplacement de la location<span class="requis">*</span></label>
							<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly [disabled]="true"
								value="{{location.emplacement.nom}} ({{location.emplacement.code}})">
							<p-dropdown *ngIf="!modeConsultation()" [options]="emplacements"
								[(ngModel)]="location.emplacement" optionLabel="nom" appendTo="body" [showClear]="true"
								filter="true" filterBy="code,nom" placeholder="Sélectionner un emplacement...">
								<ng-template pTemplate="selectedItem">
									<div *ngIf="location.emplacement">
										<div>{{location.emplacement?.nom}} ({{location.emplacement?.code}})</div>
									</div>
								</ng-template>
								<ng-template let-emplacement pTemplate="item">
									<div>
										<div>{{emplacement.nom}} ({{emplacement.code}})</div>
									</div>
								</ng-template>
							</p-dropdown>
							<small class="p-error" *ngIf="submitted && !location.emplacement">L'emplacement est
								obligatoire.</small>
						</div>
					</div> 
					<div class="fluid formgrid grid">
						<div class="flex flex-column gap-2 my-2 col-12">
							<label for="description">Notes</label>
							<span *ngIf="modeConsultation()" class="champConsultation formatted-text" style="white-space: pre-wrap;">{{location.note}}</span>
							<textarea *ngIf="!modeConsultation()" type="text" pInputTextarea id="description"
								[(ngModel)]="location.note" rows="3">
							</textarea>
						</div>
					</div>
					<div class="col-12 text-right" *ngIf="modeAjout()">
						<p-button label="Créer" (click)="creerLocation()" icon="pi pi-save" iconPos="left"></p-button>
					</div>

				</p-tabPanel>
				<p-tabPanel *ngIf="estAutorise('location_detail') && !modeAjout()" header="Documents" leftIcon="pi pi-file-pdf">
					<ng-template pTemplate="content">
						<app-document [typeLienDocument]="ETypeLienDocument.Location" [idLien]="location.locationId" [numero]="location.numero" [showFolders]="false"></app-document>
					</ng-template>
				</p-tabPanel>
			</p-tabView>
		</p-card>
	</div>


</div>

<p-dialog [(visible)]="dialogueNouvelItem" [style]="{width: '85%'}" header="Nouvel item" [modal]="true" styleClass="fluid formgrid grid">
	<ng-template pTemplate="content">
		<app-ajout-item [indLocation]="true" [submitted]="submitted" [(item)]="location.nouvelItem"></app-ajout-item>
	</ng-template>
	<ng-template pTemplate="footer">
		<div class="col-12 text-right">
			<p-button label="Fermer" (click)="dialogueNouvelItem = false" icon="pi pi-times" class="p-button-secondary" iconPos="left"></p-button>
		</div>
	</ng-template>
</p-dialog>



<!-- 

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-divider align="left">
				<div class="inline-flex align-items-center">
					<b>Général</b>
				</div>
			</p-divider>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="lastname">Date de début</label>
					<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly
						value="{{location.dateDebut | date:'yyyy-MM-dd'}}">
					<p-calendar *ngIf="!modeConsultation()" appendTo="body" showIcon=true
						[(ngModel)]="location.dateDebut" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
				</div>
				<div class="flex flex-column gap-2 my-2 col-3">
					<label for="description">Type de location</label>
					<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly
						value="{{location.typeLocation.nom}}">
					<p-dropdown *ngIf="!modeConsultation()" [options]="typesLocation"
						[(ngModel)]="location.typeLocation" optionLabel="nom" [showClear]="true" filter="true"
						filterBy="numero,nom" placeholder="Sélectionner un fournisseur...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="location.typeLocation">
								<div>{{location.typeLocation.nom}}</div>
							</div>
						</ng-template>
						<ng-template let-type pTemplate="item">
							<div>
								<div>{{type.nom}}</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !location.typeLocation">Le type de location est
						obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 my-2 col-6">
					<label for="description">Fournisseur</label>
					<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly
						value="{{location.fournisseur.nom}}">

					<p-dropdown *ngIf="!modeConsultation()" [options]="fournisseurs" [(ngModel)]="selectionFournisseur"
						optionLabel="nom" [showClear]="true" filter="true" filterBy="numero,nom"
						placeholder="Sélectionner un fournisseur...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionFournisseur">
								<div>{{selectionFournisseur.nom}} ({{selectionFournisseur.numero}})</div>
							</div>
						</ng-template>
						<ng-template let-fournisseur pTemplate="item">
							<div>
								<div>{{fournisseur.nom}} ({{fournisseur.numero}})</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !selectionFournisseur">Le fournisseur est
						obligatoire.</small>
				</div>
			</div>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-12">
					<label for="description">Description</label>
					<input type="text" pInputText id="description" [(ngModel)]="location.description"
						[readonly]="modeConsultation()" autocomplete="off" />
				</div>
			</div>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-3">
					<label for="description">Cout de location</label>
					<p-inputNumber #champPrix [readonly]="modeConsultation()" [(ngModel)]="location.coutLocation"
						mode="currency" currency="USD" locale="en-US"></p-inputNumber>
				</div>
				<div class="flex flex-column gap-2 my-2 col-3">
					<label for="description">Valeur de l'équipement</label>
					<p-inputNumber #champPrix [readonly]="modeConsultation()" [(ngModel)]="location.valeurEquipement"
						mode="currency" currency="USD" locale="en-US"></p-inputNumber>
				</div>
				<div class="flex flex-column gap-2 my-2 col-3">
					<label for="description">Heures au début de la location</label>
					<p-inputNumber [readonly]="modeConsultation()" [min]="0" [(ngModel)]="location.heuresDebut">
					</p-inputNumber>
				</div>
			</div>

			<p-divider align="left">
				<div class="inline-flex align-items-center">
					<b class="mr-3">Bon de commande</b>
					<span *ngIf="location.bonCommande"
						[class]="'statut ' + location.bonCommande.statut.nom.replace(' ','').toLowerCase()">
						{{location.bonCommande.statut.nom}}
					</span>
				</div>
			</p-divider>

			<div class="grid" *ngIf="!location.bonCommande">
				<div class="flex flex-column gap-2 my-2 col-12" *ngIf="estModifiable">
					<p-button label="Créer le bon de commande" (click)="creerBdc()" icon="pi pi-plus" iconPos="left">
					</p-button>
				</div>
			</div>
			<div class="fluid formgrid grid" *ngIf="location.bonCommande">
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="firstname">Numéro</label>
					<input id="firstname" type="text" pInputText readonly value="{{location.bonCommande.numero}}">
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="dateBdc">Date</label>
					<input id="dateBdc" type="date" pInputText readonly
						value="{{location.bonCommande.dateAchat | date:'yyyy-MM-dd'}}">
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<button pButton pRipple icon="pi pi-eye" class="p-button-success mr-2 mt-5 boutonGrille"
						(click)="voirBdc()"></button>
				</div>
			</div>

			<p-divider align="left">
				<div class="inline-flex align-items-center">
					<b>Fin de location</b>
				</div>
			</p-divider>

			<div class="fluid formgrid grid" *ngIf="location.dateFin">
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="lastname">Date de fin</label>
					<input *ngIf="modeConsultation()" id="firstname" type="text" pInputText readonly
						value="{{location.dateFin | date:'yyyy-MM-dd'}}">
					<p-calendar *ngIf="!modeConsultation()" appendTo="body" showIcon=true [(ngModel)]="location.dateFin"
						dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
				</div>
				<div class="flex flex-column gap-2 my-2 col-3">
					<label for="description">Heures à la fin de la location</label>
					<p-inputNumber [readonly]="modeConsultation()" [min]="0" [(ngModel)]="location.heuresFin">
					</p-inputNumber>
				</div>

			</div>
			<div class="fluid formgrid grid" *ngIf="location.dateFin">
				<div class="flex flex-column gap-2 my-2 col-12">
					<label for="etat">État de l'équipement au retour</label>
					<input type="text" pInputText id="etat" [(ngModel)]="location.etat" [readonly]="modeConsultation()"
						autocomplete="off" />
				</div>
			</div>

			<p-divider align="left">
				<div class="inline-flex align-items-center">
					<b>Notes</b>
				</div>
			</p-divider>
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-12">
					<label for="description">Notes</label>
					<input type="text" pInputText id="description" [(ngModel)]="location.note"
						[readonly]="modeConsultation()" autocomplete="off" />
				</div>
			</div>
		</div>
	</div>


</div> -->